// extracted by mini-css-extract-plugin
export default {"field":"Logo_field__ySr47","image":"Logo_image__a8kcM"};